import * as Sentry from "@sentry/react-native";

export const logger = {
  debug: (...args: unknown[]) => {
    if (__DEV__) {
      console.log(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (__DEV__) {
      console.warn(...args);
    }
  },
  error: (message: string, error?: unknown) => {
    if (__DEV__) {
      console.error(message, error);
    } else if (error instanceof Error) {
      Sentry.captureException(error, { extra: { message } });
    } else if (error) {
      Sentry.captureMessage(message, { extra: { error } });
    }
  },
};
